export const userAccessesSelectors = {
	isFetching: (state) => state.userAccesses.isFetching,
	isRefresh: (state) => state.userAccesses.isRefresh,
	currentProjectAccessTypes: (state) => state.userAccesses.currentProjectAccessTypes,
	parentSubmissionProjectAccessTypes: (state) => state.userAccesses.parentSubmissionProjectAccessTypes,
};
